<template>
  <div>
    <v-app-bar
      :flat="responsiveProps.flatToolbar"
      app
      :color="responsiveProps.toolbarColor"
      :height="responsiveProps.toolbarHeight"
      class="grey--bottom--border"
      style="border-color: rgba(0, 0, 0, 0.12) !important;"
    >
      <div class="d-flex align-center justify-center">
        <v-btn
          icon
          v-if="/profile/.test($route.name)"
          @click="$router.push({ name: 'home' })"
        >
          <v-icon
            :color="this.$vuetify.breakpoint.mdAndDown ? 'white' : 'primary'"
            v-text="'fas fa-arrow-left'"
          >
          </v-icon>
        </v-btn>
        <router-link :to="{ name: 'home' }" v-else>
          <v-img
            :src="
              require(`@/assets/logo/logo_${
                this.$vuetify.breakpoint.mdAndDown ? 'white' : 'primary'
              }.svg`)
            "
            width="134"
          ></v-img>
        </router-link>
      </div>

      <v-spacer class="hidden-sm-and-down"></v-spacer>
      <v-spacer class="hidden-md-and-up"></v-spacer>
      <div>
        <v-btn
          v-if="loggedIn"
          @click="$store.dispatch('share/openShareModal')"
          depressed
          v-text="$t('app.shareAGem')"
          :color="
            this.$vuetify.breakpoint.mdAndDown
              ? 'white primary--text'
              : 'secondary'
          "
          class="mr-4 hidden-sm-and-down"
        ></v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <!-- If signIn -->
            <v-btn v-if="loggedIn" icon v-on="on" class="hidden-sm-and-down">
              <v-avatar size="36" :class="responsiveProps.avatar">
                <v-img
                  v-if="creator.profilePicture"
                  :src="creator.profilePicture.small"
                  :alt="`${creator.user.username} avatar`"
                />
                <v-img
                  v-else
                  :alt="`${creator.user.username} avatar`"
                  :src="require('@/assets/defaultProfilePicture.svg')"
                />
              </v-avatar>
            </v-btn>
            <!-- If not SignIn -->
            <v-btn
              outlined
              v-else
              class="hidden-sm-and-down"
              :color="$vuetify.breakpoint.mdAndDown ? 'white' : 'primary'"
              v-on="on"
            >
              {{ $t("navigation.creatorArea") }}
            </v-btn>
          </template>
          <TheAccountOverviewModal></TheAccountOverviewModal>
        </v-menu>
        <!-- seulement si petit écran -->
        <v-btn
          icon
          @click="$store.dispatch('navigation/openDrawerView')"
          class="hidden-md-and-up"
        >
          <v-icon color="white">fas fa-bars</v-icon>
        </v-btn>
      </div>
    </v-app-bar>

    <ShareButton
      v-show="
        $vuetify.breakpoint.smAndDown &&
          !/account\/creator\/new/.test($route.name)
      "
      v-if="loggedIn"
    ></ShareButton>

    <!-- TheAccountLoginModal -->
    <v-dialog
      :value="this.loginView"
      width="450"
      @input="v => v || this.$store.dispatch('navigation/closeLoginView')"
    >
      <TheAccountLoginModal :key="loginView"></TheAccountLoginModal>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import TheAccountLoginModal from "../../account/components/TheAccountLoginModal";
import ShareButton from "../../share/components/ShareButton";
import TheAccountOverviewModal from "../../account/components/TheAccountOverviewModal";

export default {
  name: "AppNavigation",
  components: {
    TheAccountLoginModal,
    TheAccountOverviewModal,
    ShareButton
  },
  computed: {
    ...mapState({
      loginView: state => state.navigation.login.view,
      signUpView: state => state.navigation.signUp.view
    }),
    ...mapGetters({
      loggedIn: "account/loggedIn"
    }),
    drawerIcon: function() {
      return this.drawer ? "fas fa-times" : "fas fa-bars";
    },
    isDialogShare() {
      return this.$store.getters.isDialogShare;
    },
    isDialogProfile() {
      return this.$store.getters.isDialogProfile;
    },
    isPersistent() {
      return this.$store.getters.isPersistent;
    },
    creator() {
      return this.$store.getters.creator;
    },
    responsiveProps() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        return {
          toolbarColor: "primary",
          toolbarHeight: "56px",
          dark: true,
          flatToolbar: false,
          avatar: "white--border border-1"
        };
      } else
        return {
          toolbarColor: "white",
          toolbarHeight: "64px",
          dark: false,
          flatToolbar: true,
          avatar: ""
        };
    }
  },
  created() {
    if (this.loggedIn) {
      this.$store.dispatch("getCreatorInformations");
      this.$store.dispatch("organization/myAccount", null, { root: true });
    }
  },
  methods: {
    toogleDialogs(action) {
      this.$store.commit("toggleDialogs", action);
    }
  }
};
</script>
